import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "accordion-title" }
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = { class: "icon-button small" }
const _hoisted_7 = { class: "accordion-title" }
const _hoisted_8 = { class: "flex-1" }
const _hoisted_9 = { class: "icon-button small" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_position = _resolveComponent("position")!
  const _component_date_type = _resolveComponent("date-type")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_score_analyse = _resolveComponent("score-analyse")!
  const _component_deduct = _resolveComponent("deduct")!
  const _component_sleep_curve = _resolveComponent("sleep-curve")!
  const _component_snore_level = _resolveComponent("snore-level")!
  const _component_heart_rate = _resolveComponent("heart-rate")!
  const _component_breath_rate = _resolveComponent("breath-rate")!
  const _component_turn_over = _resolveComponent("turn-over")!
  const _component_temperature = _resolveComponent("temperature")!
  const _component_humidity = _resolveComponent("humidity")!
  const _component_calendar = _resolveComponent("calendar")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_position, {
          modelValue: $setup.leftRight,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.leftRight) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("button", {
          class: "icon-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.dialogShow = true))
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("i", { class: "iconfont iconreport-bth-liri" }, null, -1)
        ]))
      ]),
      _createVNode(_component_date_type, {
        active: "day",
        "equipment-id": $props.equipmentId,
        class: "mt-4"
      }, null, 8, ["equipment-id"]),
      ($setup.emptyMessage)
        ? (_openBlock(), _createBlock(_component_van_empty, {
            key: 0,
            image: "error",
            description: $setup.emptyMessage
          }, null, 8, ["description"]))
        : ($setup.sleepDataList)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.sleepDataList.filter((item) => item !== null), (item, key) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                _createElementVNode("div", {
                  class: "mt-4",
                  onClick: ($event: any) => ($setup.changeCard(key))
                }, [
                  (item.analysis.reportFlag === 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("day.longSleepReport")), 1),
                          _createElementVNode("button", _hoisted_6, [
                            _createVNode(_component_van_icon, {
                              name: $setup.activeList.includes(key) ? 'arrow-up' : 'arrow-down'
                            }, null, 8, ["name"])
                          ])
                        ]),
                        _createVNode(_component_score_analyse, {
                          "curr-date": $setup.currDate,
                          analysis: item.analysis,
                          summary: item.summary,
                          class: "mt-2"
                        }, null, 8, ["curr-date", "analysis", "summary"])
                      ], 64))
                    : (item.analysis.reportFlag === 2)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("day.shortSleepReport")), 1),
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_van_icon, {
                                name: $setup.activeList.includes(key) ? 'arrow-up' : 'arrow-down'
                              }, null, 8, ["name"])
                            ])
                          ]),
                          _createVNode(_component_score_analyse, {
                            "curr-date": $setup.currDate,
                            analysis: item.analysis,
                            summary: item.summary,
                            class: "mt-2"
                          }, null, 8, ["curr-date", "analysis", "summary"])
                        ], 64))
                      : _createCommentVNode("", true)
                ], 8, _hoisted_3),
                ($setup.activeList.includes(key))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (item.analysis.reportFlag === 1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_deduct, {
                              analysis: item.analysis
                            }, null, 8, ["analysis"]),
                            (
                  item.analysis.sleepCurveArray &&
                    item.analysis.sleepCurveArray.length
                )
                              ? (_openBlock(), _createBlock(_component_sleep_curve, {
                                  key: 0,
                                  "y-axis": item.analysis.sleepCurveArray,
                                  "start-time": item.summary.startTime,
                                  "deep-sleep-perc": item.analysis.deepSleepPerc,
                                  "in-sleep-perc": item.analysis.inSleepPerc,
                                  "light-sleep-perc": item.analysis.lightSleepPerc,
                                  "wake-sleep-perc": item.analysis.wakeSleepPerc
                                }, null, 8, ["y-axis", "start-time", "deep-sleep-perc", "in-sleep-perc", "light-sleep-perc", "wake-sleep-perc"]))
                              : _createCommentVNode("", true),
                            (
                  item.analysis.snore_number &&
                    item.analysis.snore_level?.length
                )
                              ? (_openBlock(), _createBlock(_component_snore_level, {
                                  key: 1,
                                  "y-axis": item.analysis.snore_level,
                                  "start-time": item.summary.startTime,
                                  snore_high_proportion: item.analysis.snore_non_proportion,
                                  snore_low_proportion: item.analysis.snore_low_proportion,
                                  snore_mid_proportion: item.analysis.snore_mid_proportion,
                                  snore_non_proportion: item.analysis.snore_high_proportion,
                                  snore_duration: item.analysis.snore_duration,
                                  snore_number: item.analysis.snore_number
                                }, null, 8, ["y-axis", "start-time", "snore_high_proportion", "snore_low_proportion", "snore_mid_proportion", "snore_non_proportion", "snore_duration", "snore_number"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      _createVNode(_component_heart_rate, {
                        "y-axis": item.detail.heartRate,
                        "start-time": item.summary.startTime,
                        "average-heart-beat-rate": item.analysis.averageHeartBeatRate
                      }, null, 8, ["y-axis", "start-time", "average-heart-beat-rate"]),
                      _createVNode(_component_breath_rate, {
                        "average-breath-rate": item.analysis.averageBreathRate,
                        "y-axis": item.detail.breathRate,
                        "start-time": item.summary.startTime
                      }, null, 8, ["average-breath-rate", "y-axis", "start-time"]),
                      _createVNode(_component_turn_over, {
                        "y-axis": item.analysis.turnOverStatusAry,
                        "start-time": item.summary.startTime
                      }, null, 8, ["y-axis", "start-time"]),
                      (item.detail.etemp && item.detail.etemp.length)
                        ? (_openBlock(), _createBlock(_component_temperature, {
                            key: 1,
                            "y-axis": item.detail.etemp,
                            "start-time": item.summary.startTime
                          }, null, 8, ["y-axis", "start-time"]))
                        : _createCommentVNode("", true),
                      (item.detail.ehumidity && item.detail.ehumidity.length)
                        ? (_openBlock(), _createBlock(_component_humidity, {
                            key: 2,
                            "y-axis": item.detail.ehumidity,
                            "start-time": item.summary.startTime
                          }, null, 8, ["y-axis", "start-time"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_dialog, {
      show: $setup.dialogShow,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (($setup.dialogShow) = $event)),
      "show-confirm-button": false,
      "close-on-click-overlay": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_calendar, {
          modelValue: $setup.currDate,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.currDate) = $event)),
          "equipment-id": $props.equipmentId,
          "left-right": $setup.leftRight
        }, null, 8, ["modelValue", "equipment-id", "left-right"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}